import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 48,
    lineHeight: 1,
    letterSpacing: 0,
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: 'Raleway',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.3,
    letterSpacing: 0,
    textAlign: 'center',
  },
  formFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(2),
    },
  },
  submitButton: {
    height: 56,
    minWidth: 180,
    fontWeight: 600,
    fontSize: '0.95rem',
    letterSpacing: '0.04em',
    padding: theme.spacing(0, 5),
    borderRadius: 12,
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}))

export default useStyles
